// For tracking a quote view
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { quoteIdZodSchema } from "@@/shared/quotes/quote-id";

const viewQuoteCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("VIEW_QUOTE_COMMAND"),
    quoteId: quoteIdZodSchema,
    providerId: providerIdZodSchema,

    token: z.string(),
});

type ViewQuoteCommand = z.infer<typeof viewQuoteCommandZodSchema>;

const viewQuoteCommandFactoryParamsZodObject = viewQuoteCommandZodSchema.omit({
    _id: true,
    _type: true,
});

type ViewQuoteCommandFactoryParams = z.infer<
    typeof viewQuoteCommandFactoryParamsZodObject
>;

const viewQuoteCommandFactory = (
    params: ViewQuoteCommandFactoryParams,
): ViewQuoteCommand => {
    return {
        ...params,
        _id: generateId("VIEW_QUOTE_COMMAND__"),
        _type: "VIEW_QUOTE_COMMAND",
    };
};

export {
    viewQuoteCommandFactory,
    viewQuoteCommandFactoryParamsZodObject,
    viewQuoteCommandZodSchema,
};

export type { ViewQuoteCommand, ViewQuoteCommandFactoryParams };
